// src/App.js
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Home from './components/Home';
import Dashboard from './components/Dashboard';
import UserProfile from './components/UserProfile';
import AdminPage from './components/AdminPage';
import CircuitManager from './components/CircuitManager';
import CircuitSummary from './components/CircuitSummary';
import Login from './components/Login';
import SignUp from './components/SignUp';
import HistoricalResults from './components/HistoricalResults';
import Community from './components/Community';
import About from './components/About';
import Calendar from './components/Calendar';
import News from './components/News';
import Rules from './components/Rules';
import { AuthProvider } from './utils/AuthContext';
import { CommunityNotificationProvider } from './utils/CommunityNotificationContext';
import { AdminNotificationProvider } from './utils/AdminNotificationContext';
import { NewsNotificationProvider } from './utils/NewsNotificationContext';
import PrivateRoute from './utils/PrivateRoute';
import LeftNav from './components/LeftNav';

function App() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const isAuthPage = ['/login', '/signup'].includes(location.pathname);

  return (
    <AuthProvider>
      <CommunityNotificationProvider>
        <AdminNotificationProvider>
        <NewsNotificationProvider>
          <Box sx={{ display: 'flex' }}>
            {!isAuthPage && <LeftNav />}
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: isAuthPage ? 0 : 3,
                width: isAuthPage ? '100%' : { md: `calc(100% - 220px)` },
                mt: (!isAuthPage && isMobile) ? '64px' : 0,
              }}
            >
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/historical-results" element={<HistoricalResults />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/news" element={<News />} />
                <Route path="/rules" element={<Rules />} />
                <Route path="/community" element={<Community />} />
                <Route path="/profile" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                <Route path="/users/:userId" element={<UserProfile />} />
                <Route path="/circuit/:circuitId" element={<CircuitSummary />} />
                <Route path="/admin" element={<PrivateRoute roles={['admin']}><AdminPage /></PrivateRoute>} />
                <Route path="/circuit-manager" element={<PrivateRoute roles={['admin']}><CircuitManager /></PrivateRoute>} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
              </Routes>
            </Box>
          </Box>
          </NewsNotificationProvider>
        </AdminNotificationProvider>
      </CommunityNotificationProvider>
    </AuthProvider>
  );
}

export default App;